// Angular
import { Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local library
import {
  IGetPoolMatrixRequest,
  IGetPoolMatrixResponse,
  IGetPoolTotalsRequest,
  IGetPoolsTotalsRequest,
  IGetPoolsTotalsResponse,
  IGetRaceAllOddsMatrixesRequest,
  IGetWillPaysResponse,
  IToteOddsMatrixCallResponse,
  ITotePoolInfoCallResponse,
  ITotePoolTotalResponse
} from '@amwager/util-ts';

// Local file
import { HttpService } from '../services';



// TODO: write tests
@Injectable()
export class TotePoolInfoAPIService {
  private readonly API_URL = '/api/TotePoolInfo';

  constructor(
    private readonly httpService: HttpService,
  ) {}


  /**
   * GET API
   */

  /**
   * @description
   * Get a list of willpays for the specified race.
   *
   * @param raceId number
   * @param eventId string
   * @param runId string
   * @returns Observable<IGetWillPaysResponse>
   */
  getWillPays$(raceId: number, eventId: string, runId: string)
    : Observable<IGetWillPaysResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetWillpays`,
      params: this.httpService.objToHttpParams({
        raceId,
        eventId,
        runId
      })
    });
  }

  /**
   * @description
   * Get the pool totals of a specific race and pool.
   *
   * @param requests IGetPoolTotalsRequest
   * @returns Observable<ITotePoolTotalResponse>
   */
  getPoolTotals$(requests: IGetPoolTotalsRequest)
    : Observable<ITotePoolTotalResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetPoolTotals`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get the pool totals of a specific race.
   *
   * @param requests IGetPoolsTotalsRequest
   * @returns Observable<IGetPoolsTotalsResponse>
   */
  getPoolsTotals$(requests: IGetPoolsTotalsRequest)
    : Observable<IGetPoolsTotalsResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetPoolsTotals`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get the odds matrix for the requested race
   *
   * @param requests IGetRaceAllOddsMatrixesRequest
   * @returns Observable<IToteOddsMatrixCallResponse>
   */
  getRaceAllOddsMatrixes$(requests: IGetRaceAllOddsMatrixesRequest)
    : Observable<IToteOddsMatrixCallResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetRaceAllOddsMatrixes`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get the Pool matrix
   *
   * @param requests IGetPoolTotalsRequest
   * @returns Observable<ITotePoolInfoCallResponse>
   */
  getPoolMatrix$(requests: IGetPoolMatrixRequest)
    : Observable<IGetPoolMatrixResponse> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetPoolMatrixV2`,
      params: this.httpService.objToHttpParams(requests as unknown as Record<string, unknown>)
    });
  }

  /**
   * @description
   * Get the carryover amounts for today
   *
   * @param minimumAmount number
   * @returns Observable<{}>
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  getCarryovers$(minimumAmount?: number): Observable<{}> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetCarryovers`,
      params: this.httpService.objToHttpParams({
        minimumAmount
      })
    });
  }

}
